import TabContainer from './TabContainer'

export default TabContainer
